import { inject, Injectable, Injector } from '@angular/core';
import { OAuthStorage } from 'angular-oauth2-oidc';
import { NetworkService } from 'src/app/core/services/network/network.service';
import { PwaService } from 'src/app/core/services/pwa/pwa.service';

@Injectable({
  providedIn: 'root'
})
export class BizzMineSessionStorageService implements OAuthStorage {

  private pwaService = inject(PwaService);
  private injector = inject(Injector);

  private get networkService(): NetworkService {
    return this.injector.get(NetworkService);
  }
  public clear(): void {
    if(this.pwaService.isPwa()) localStorage.clear();

    if (navigator.cookieEnabled) {
      return sessionStorage.clear()
    }
  }

  public getItem(key: string): string | null {
    return this.get(key) ?? null;
  }

  public setItem(key: string, value: string): void {
    this.set(key, value);
  }
  
  public removeItem(key: string): void {
    this.remove(key);
  }

  public key(index: number): string | null {
    if (navigator.cookieEnabled) {
      sessionStorage.key(index);
    }
    return null;
  }

  public length = navigator.cookieEnabled ? sessionStorage.length : 0;

  public get(key: string): string | null {
    if(this.pwaService.isPwa() && this.networkService.isOnline) {
      return localStorage.getItem(key);
    }else if (navigator.cookieEnabled) {
      return  sessionStorage.getItem(key);
    }
    return null;
  }

  public set(key: string, value: string): void {
    if(this.pwaService.isPwa()) localStorage.setItem(key, value);
    if (navigator.cookieEnabled) {
      sessionStorage.setItem(key, value);
    }
  }

  public remove(key: string): void {
    if(this.pwaService.isPwa()) localStorage.removeItem(key);
    if (navigator.cookieEnabled) {
      sessionStorage.removeItem(key);
    }
  }
}